import type { ReactNode } from 'react';

export const symbol_password_2_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M151.76-454Q105-454 72.5-486.74 40-519.47 40-566.24 40-613 72.74-645.5q32.73-32.5 79.5-32.5 46.76 0 79.26 32.74 32.5 32.73 32.5 79.5 0 46.76-32.74 79.26-32.73 32.5-79.5 32.5Zm576.74-33.38Q696-519.75 696-566q0-47.08 32.74-80.04Q761.47-679 808.24-679q46.76 0 79.26 32.96Q920-613.08 920-566q0 46.25-32.74 78.62Q854.53-455 807.76-455q-46.76 0-79.26-32.38ZM592-566q0 17-5 34t-16 31q-5 8-14 8t-16-7L414-627q-7-7-6.5-16t7.5-15q14-11 30.5-16t34.5-5q46.67 0 79.33 32.96Q592-613.08 592-566ZM110-200q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-260 110-260h500L84-786q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l709 709q9 9 9 21t-9 21q-9 9-21.5 9T793-78L669.98-200H110Z"
		/>
	</svg>
);
